import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { Observable,map,of } from 'rxjs';



@Injectable({
    providedIn: 'root'
})
export class FirstLoginGuard implements CanActivate, CanActivateChild,CanLoad
{
    /**
     * Constructor
     */
    constructor(
        private _userService:UserService,
        private _router: Router
    )
    {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>
    {
        return this._userService.get()
        .pipe(map(
            (result) => {
                if (result && result.first_login != 1) {
                    this._router.navigateByUrl('/apps/first-login');
                    return false;
                } else {
                    return true;
                }
            }
        ));
        
    }

    /**
     * Can activate child
     *
     * @param childRoute
     * @param state
     */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        return this._userService.get()
        .pipe(map(
            (result) => {
                if (result && result.first_login != 1) {
                    this._router.navigateByUrl('/apps/first-login');
                    return false;
                } else {
                    return true;
                }
            }
        ));

    }

    canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return this._userService.get()
        .pipe(map(
            (result) => {
                if (result && result.first_login != 1) {
                    this._router.navigateByUrl('/apps/first-login');
                    return false;
                } else {
                    return true;
                }
            }
        ));
    }


}
